var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "div",
        { staticClass: "flex items-center flex-wrap" },
        [
          _vm._l(_vm.list, function(item, index) {
            return _c(
              "div",
              {
                key: index,
                staticClass: "img mar10-r radius5 pointer relative",
                on: {
                  click: function($event) {
                    return _vm.disabledPreview(item)
                  }
                }
              },
              [
                _vm.isVideo(item)
                  ? _c("img", {
                      attrs: {
                        src:
                          item +
                          "?vframe/png/offset/1/w/80/h/80/imageMogr2/thumbnail/80000@"
                      }
                    })
                  : _c("img", {
                      attrs: { src: item + "?imageView2/1/w/80/h/80" }
                    }),
                _vm.isVideo(item)
                  ? _c("img", {
                      staticClass: "absolute video-icon",
                      attrs: {
                        src:
                          "https://nfs.nxin.com/cms_image_c34fcdac-7f89-454c-950c-3eb84a87c497.png?imageView2/1/w/30/h/30"
                      }
                    })
                  : _vm._e(),
                _c(
                  "div",
                  {
                    staticClass:
                      "absolute flex white justify-center items-center",
                    class: { hover: !_vm.disabled }
                  },
                  [
                    _vm.isVideo(item)
                      ? _c("i", {
                          staticClass: "el-icon-zoom-in mar20-r pointer",
                          on: {
                            click: function($event) {
                              return _vm.videoPreview(item)
                            }
                          }
                        })
                      : _c("i", {
                          staticClass: "el-icon-zoom-in mar20-r pointer",
                          on: {
                            click: function($event) {
                              return _vm.imgPreview(item)
                            }
                          }
                        }),
                    _c("i", {
                      staticClass: "el-icon-delete pointer",
                      on: {
                        click: function($event) {
                          return _vm.del(index)
                        }
                      }
                    })
                  ]
                )
              ]
            )
          }),
          !_vm.disabled && _vm.fileList.length < _vm.limit
            ? [
                _c(
                  "el-upload",
                  {
                    staticClass: "mar10-r",
                    attrs: {
                      action: _vm.env.VUE_APP_fileserver + "persistentUpload",
                      "file-list": _vm.fileList,
                      "on-success": _vm.uploadSuccess,
                      "before-upload": _vm.uploadBefore,
                      "show-file-list": false
                    }
                  },
                  [
                    _c(
                      "div",
                      {
                        staticClass:
                          "flex flex-column justify-center bg-f5 pointer items-center img radius5"
                      },
                      [
                        _c("img", {
                          staticClass: "block",
                          attrs: { src: require("./img/pc.png") }
                        }),
                        _c("div", { staticClass: "mar5-t f12 gray9" }, [
                          _vm._v("上传文件")
                        ])
                      ]
                    )
                  ]
                ),
                _c(
                  "div",
                  {
                    staticClass:
                      "flex flex-column justify-center bg-f5 pointer items-center img mar10-r radius5",
                    on: { click: _vm.mobUpload }
                  },
                  [
                    _c("img", {
                      staticClass: "block",
                      attrs: { src: require("./img/pc.png") }
                    }),
                    _c("div", { staticClass: "mar5-t f12 gray9" }, [
                      _vm._v("手机传图")
                    ])
                  ]
                ),
                _c("div", { staticClass: "gray9" }, [
                  _vm._v("\n        还可上传"),
                  _c("span", { staticClass: "red" }, [
                    _vm._v(_vm._s(_vm.limit - _vm.fileList.length))
                  ]),
                  _vm._v("个\n      ")
                ])
              ]
            : _vm._e()
        ],
        2
      ),
      !_vm.disabled
        ? [
            _c("div", { staticClass: "gray9 f12 mar10-t" }, [
              _vm._v("图片仅支持上传png,jpg,jpeg格式且大小不超过2M")
            ]),
            _c("div", { staticClass: "gray9 mar5-t f12" }, [
              _vm._v("视频仅支持上传mp4,webm,ogv且大小不超过50M")
            ])
          ]
        : _vm._e(),
      _c(
        "el-dialog",
        {
          attrs: { visible: _vm.dialogVisible },
          on: {
            "update:visible": function($event) {
              _vm.dialogVisible = $event
            }
          }
        },
        [_c("img", { attrs: { width: "100%", src: _vm.dialogImageUrl } })]
      ),
      _c(
        "el-dialog",
        {
          staticClass: "text-center mob-upload",
          attrs: { visible: _vm.mobUploadVisible, "show-close": false },
          on: {
            "update:visible": function($event) {
              _vm.mobUploadVisible = $event
            }
          }
        },
        [
          _c("div", { staticClass: "relative" }, [
            _c("i", {
              staticClass: "gray9 f20 fb el-icon-close absolute pointer close",
              on: {
                click: function($event) {
                  _vm.mobUploadVisible = false
                }
              }
            })
          ]),
          _c("div", { staticClass: "f24 fb pad40-tb gray3" }, [
            _vm._v("手机上传图片")
          ]),
          _c(
            "div",
            {
              staticClass: "border radius4 flex justify-around items-center qr"
            },
            [
              _c("canvas", {
                ref: "qrCodeCanvas",
                attrs: { width: "140", height: "140" }
              })
            ]
          ),
          _c("div", { staticClass: "gray6 pad20-t f14" }, [
            _vm._v("请使用"),
            _c("span", { staticClass: "pad10-lr red" }, [_vm._v("微信")]),
            _vm._v("或"),
            _c("span", { staticClass: "pad10-lr red" }, [_vm._v("智农通")]),
            _vm._v("扫描二维码")
          ])
        ]
      )
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }